import ReactDOM from "react-dom/client"
import React from "react"
import AddToCart from "@bodeboca/algolia/components/wineblock/add-to-cart"
import InsightsUtils from "@bodeboca/algolia/utils/insights"

function getAttributes ( node ) {
  let i,
    attributeNodes = node.attributes,
    length = attributeNodes.length,
    attrs = {}

  for ( i = 0; i < length; i++ ) attrs[attributeNodes[i].name] = attributeNodes[i].value
  return attrs
}


(function (Drupal, drupalSettings, document, ReactDOM, jQuery) {
  Drupal.behaviors.bb_algolia_init_elements = {
    attach: function () {

      // Add to cart elements.
      let elements = document.getElementsByTagName('add-to-cart')
      for (let i = 0; i < elements.length; i++) {
        let attrs = getAttributes(elements[i])
        let elementRoot = ReactDOM.createRoot(elements[i])
        let queryId = InsightsUtils.getQueryId(attrs['product_id'], false)
        elementRoot.render(<React.StrictMode>
          <AddToCart
            buttonClass={attrs['button_class']}
            productId={attrs['product_id']}
            productUrl={attrs['url']}
            queryID={queryId}
            title={attrs['title']}/>
        </React.StrictMode>)
      }
      
    },
  }
})(Drupal, drupalSettings, document, ReactDOM, jQuery)
